import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'history';

class HistoryService extends ServiceBase {
    /**
     * returns rolling candles over N days, 7,14,30,90
     * data from BackTest plugin kraken
     * @returns {Promise}
     */
    getRollingWindows = (sid, window) => {
        if (window === undefined) {
            window = 0;
        }
        if (sid === undefined) {
            sid = 0;
        }

        const url = `${baseUrl}/${service}/rolling/candles?sid=${sid}&window=${window}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * returns rolling candles over N days, 7,14,30,90
     * data from BackTest plugin kraken
     * @returns {Promise}
     */
    getSmaWindow = (sid, window, limit = 10) => {
        if (window === undefined) {
            window = 0;
        }
        if (sid === undefined) {
            sid = 0;
        }

        const url = `${baseUrl}/${service}/sma/slots?sid=${sid}&window=${window}&limit=${limit}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * returns atr values for today
     * data from BackTest plugin kraken
     * @returns {Promise}
     */
    getAtr = (sid = 0) => {
        if (sid === undefined || sid === '') {
            sid = 0;
        }

        const url = `${baseUrl}/${service}/atr?sid=${sid}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * returns atr values for today
     * data from BackTest plugin kraken
     * @returns {Promise}
     */
    getRsi = (sid = 0, window = 0) => {
        if (sid === undefined || sid === '') {
            sid = 0;
        }

        const url = `${baseUrl}/${service}/rsi/slots?sid=${sid}&period=${window}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };
}

const historyService = new HistoryService();
export default historyService;
